import cn from 'classnames';
import BaseLogo from '@dealroadshow/uikit-logo/BaseLogo';
import { ILogoProps } from '@dealroadshow/uikit-logo/types';

import creditflowresearchText from './creditflowresearch.text.inline.svg?raw';
import styles from '../styles.module.scss';

export const LogoCreditFlowResearchText = (props: ILogoProps) => (
  <BaseLogo
    { ...props }
    logoSvg={ creditflowresearchText }
    className={ cn(styles.logoCreditflowresearch, props.className) }
  />
);
